import React from "react";
import { Snackbar as MuiSnackbar, Alert } from "@mui/material";
import { useSelector } from "react-redux";
import { useSnackbar } from "./useSnackbar";

const Snackbar = () => {
  const { open, message, severity, autoHideDuration, anchorOrigin } = useSelector(
    (state) => state.snackbar
  );
  const { hide } = useSnackbar();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    hide();
  };

  return (
    <MuiSnackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
    >
      <Alert 
        onClose={handleClose} 
        severity={severity} 
        sx={{ width: "100%" }}
      >
        {message}
      </Alert>
    </MuiSnackbar>
  );
};

export default Snackbar;
